<template>
    <div id="editor_right">
        <div class="editor_right1" v-if="expandShow">
            <editorNovel v-if="editorIndex == 0"></editorNovel>
            <editorOutline v-if="editorIndex == 1"></editorOutline>
        </div>
        <div class="editor_right2">
            <div class="editor_right2_1" @click="open()">
                <img src="../assets/image/icon_editor1.png" alt="">
                展开
            </div>
            <div class="cursor_1" :class="editorIndex == i ? 'editor_right2_2 editor_right2_3' : 'editor_right2_2'"
                v-for="(item, i) in editorRight" :key="i" @click="editorSelect(i)">
                <img :src="editorIndex == i ? item.uicon : item.icon" alt="">
                {{ item.name }}
            </div>
        </div>
    </div>
</template>
<script>
import data from '@/assets/data';
import editorNovel from '@/components/editor_novel' //小说信息
import editorOutline from '@/components/editor_outline' //小说信息
import { EventBus } from '@/utils/eventBus';
export default {
    components: {
        editorNovel, editorOutline
    },
    data() {
        return {
            editorRight: data.editorRight,
            editorIndex: 0, //右边选择下标
            expandShow: true, //展开收藏
        }
    },
    created() {
        let editItem = JSON.parse(sessionStorage.getItem('editItem'))
        if (editItem.editType) {
            this.editorRight = this.editorRight.slice(0, 1)
            this.editorIndex = 0
        } else if (editItem.editText) {
            this.editorIndex = 1
            setTimeout(() => {
                EventBus.$emit('toPage', editItem.chapter - 1)
            }, 50)

        }
        // console.log(editItem)
    },
    methods: {
        //右边切换
        editorSelect(i) {
            this.editorIndex = i
            if (i == 1) {
                let editItem = JSON.parse(sessionStorage.getItem('editItem'))
                setTimeout(() => {
                    EventBus.$emit('toPage', editItem.chapter - 1)
                }, 50)
            }
        },
        open() {
            this.expandShow = !this.expandShow
            let editItem = JSON.parse(sessionStorage.getItem('editItem'))
            setTimeout(() => {
                EventBus.$emit('toPage', editItem.chapter - 1)
            }, 50)
        }
    }

}
</script>
<style>
#editor_right {
    height: 100%;
    box-shadow: 0px 0 8px 0px rgba(117, 53, 0, 0.06);
    border-radius: 8px 0 0 8px;
    overflow: hidden;
    display: flex;
}

.editor_right1 {
    width: 270px;
    height: 100%;
    background-color: #FFFFFF;
    border-right: 1px solid #E6EBF0;
}

.editor_right2 {
    width: 70px;
    display: flex;
    flex-flow: column;
    align-items: center;
    background-color: #FFFFFF;
}

.editor_right2_1 {
    width: 100%;
    height: 67px;
    font-size: 15px;
    color: #666666;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #E6EBF0;
    cursor: pointer;
}

.editor_right2_1 img {
    width: 21px;
    height: 21px;
    margin-bottom: 5px;
}

.editor_right2_2 {
    width: 45px;
    height: 60px;
    border-radius: 5px;
    font-weight: bold;
    font-size: 13px;
    color: #444444;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    margin: 8px 0;
}

.editor_right2_3 {
    background-color: var(--tech-table-bg);
    color: var(--tech-primary);
}

.editor_right2_2 img {
    width: 21px;
    height: 21px;
    margin-bottom: 4px;
}
</style>